import React, { useEffect } from 'react';

import { hashHistory, RouteComponentProps } from 'react-router';

import { LoadingSpinner } from '../../components/layouts';
import { DispatchProps } from './index';

type AppRoute = RouteComponentProps<
  {
    bounceurl: string;
  },
  {},
  {}
>;

type Props = DispatchProps & AppRoute;

export function Bounce(props: Props): JSX.Element {
  const { location, params, SetBounced: setBounced, updateRouterState } = props;
  const { bounceurl } = params;

  useEffect(() => {
    setBounced(true);
    updateRouterState({ pathname: location.pathname, params });

    hashHistory.replace(bounceurl.substring(1));
  }, []);

  return <LoadingSpinner />;
}
